export enum GTMEcommerceItemStatus {
    Active = "aktywna",
    Archived = "archiwalna"
}
export enum GTMEcommerceItemStatus {
    Active = "aktywna",
    Archived = "archiwalna"
}
